// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SkillBanner_SkillBanner__x4rPl {
  padding: 0.5rem;
  --experience-animation-color: rgba(255, 111, 105, 0.2);
}
.SkillBanner_SkillBanner__x4rPl .SkillBanner_imageContainer__Yv1Ad {
  display: flex;
  justify-content: center;
  align-items: center;
}
.SkillBanner_SkillBanner__x4rPl .SkillBanner_imageContainer__Yv1Ad img {
  height: 2.7rem;
  width: 2.7rem;
}
@media only screen and (max-width: 768px) {
  .SkillBanner_SkillBanner__x4rPl .SkillBanner_imageContainer__Yv1Ad img {
    width: 2rem;
    height: 2rem;
  }
}
.SkillBanner_SkillBanner__x4rPl .SkillBanner_imageContainer__Yv1Ad img {
  transition: transform 0.15s ease-in-out;
  position: absolute;
}
.SkillBanner_SkillBanner__x4rPl .SkillBanner_textContainer__jR0Eb {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 0.4rem;
  text-align: center;
  font-size: 0.96rem;
  border-radius: 50vw;
  opacity: 0;
  transition: opacity 0.25s ease-in-out;
}
.SkillBanner_SkillBanner__x4rPl .SkillBanner_beginner__p6hjR {
  overflow: hidden;
  background-color: #ddd;
  position: relative;
}
.SkillBanner_SkillBanner__x4rPl .SkillBanner_beginner__p6hjR::before {
  height: 20%;
  content: "";
  width: 100%;
  background-color: var(--experience-animation-color);
  position: absolute;
  bottom: 0;
  animation: SkillBanner_fadeIn__qR7Tc 1.1s ease-in-out both, SkillBanner_bottomToTop__oOJMg 0.55s cubic-bezier(0.74, 0.06, 0.4, 0.92) both;
}
.SkillBanner_SkillBanner__x4rPl .SkillBanner_moderate__\\+tBf3 {
  overflow: hidden;
  background-color: #ddd;
  position: relative;
}
.SkillBanner_SkillBanner__x4rPl .SkillBanner_moderate__\\+tBf3::before {
  height: 60%;
  content: "";
  width: 100%;
  background-color: var(--experience-animation-color);
  position: absolute;
  bottom: 0;
  animation: SkillBanner_fadeIn__qR7Tc 1.1s ease-in-out both, SkillBanner_bottomToTop__oOJMg 0.55s cubic-bezier(0.74, 0.06, 0.4, 0.92) both;
}
.SkillBanner_SkillBanner__x4rPl .SkillBanner_experienced__sNIYc {
  overflow: hidden;
  background-color: #ddd;
  position: relative;
}
.SkillBanner_SkillBanner__x4rPl .SkillBanner_experienced__sNIYc::before {
  height: 90%;
  content: "";
  width: 100%;
  background-color: var(--experience-animation-color);
  position: absolute;
  bottom: 0;
  animation: SkillBanner_fadeIn__qR7Tc 1.1s ease-in-out both, SkillBanner_bottomToTop__oOJMg 0.55s cubic-bezier(0.74, 0.06, 0.4, 0.92) both;
}
.SkillBanner_SkillBanner__x4rPl .SkillBanner_darkTheme__o6Db\\+ {
  padding: inherit;
  border-radius: inherit;
  background-color: rgba(255, 255, 255, 0.05);
  --experience-animation-color: rgba(131, 133, 138, 0.2);
  width: 8rem;
  height: 4rem;
}
.SkillBanner_SkillBanner__x4rPl .SkillBanner_darkTheme__o6Db\\+:hover img {
  transform: translate(0%, -20%);
}
.SkillBanner_SkillBanner__x4rPl .SkillBanner_darkTheme__o6Db\\+:hover .SkillBanner_textContainer__jR0Eb {
  opacity: 1;
}
@media only screen and (max-width: 768px) {
  .SkillBanner_SkillBanner__x4rPl .SkillBanner_darkTheme__o6Db\\+ {
    width: 3rem;
    height: 2rem;
  }
  .SkillBanner_SkillBanner__x4rPl .SkillBanner_darkTheme__o6Db\\+:hover img {
    transform: none;
  }
  .SkillBanner_SkillBanner__x4rPl .SkillBanner_darkTheme__o6Db\\+:hover .SkillBanner_textContainer__jR0Eb {
    opacity: 0;
  }
}
.SkillBanner_SkillBanner__x4rPl .SkillBanner_darkTheme__o6Db\\+ {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  border: solid transparent;
  border-radius: 10rem;
}
.SkillBanner_SkillBanner__x4rPl .SkillBanner_lightTheme__xkiuG {
  padding: inherit;
  border-radius: inherit;
  background-color: rgba(208, 209, 255, 0.5);
  --experience-animation-color: rgba(105, 140, 255, 0.3);
  width: 8rem;
  height: 4rem;
}
.SkillBanner_SkillBanner__x4rPl .SkillBanner_lightTheme__xkiuG:hover img {
  transform: translate(0%, -20%);
}
.SkillBanner_SkillBanner__x4rPl .SkillBanner_lightTheme__xkiuG:hover .SkillBanner_textContainer__jR0Eb {
  opacity: 1;
}
@media only screen and (max-width: 768px) {
  .SkillBanner_SkillBanner__x4rPl .SkillBanner_lightTheme__xkiuG {
    width: 3rem;
    height: 2rem;
  }
  .SkillBanner_SkillBanner__x4rPl .SkillBanner_lightTheme__xkiuG:hover img {
    transform: none;
  }
  .SkillBanner_SkillBanner__x4rPl .SkillBanner_lightTheme__xkiuG:hover .SkillBanner_textContainer__jR0Eb {
    opacity: 0;
  }
}
.SkillBanner_SkillBanner__x4rPl .SkillBanner_lightTheme__xkiuG {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  border: solid transparent;
  border-radius: 10rem;
}
.SkillBanner_SkillBanner__x4rPl .SkillBanner_colorfulTheme__NBjdm {
  padding: inherit;
  border-radius: inherit;
  background-color: rgba(208, 209, 255, 0.5);
  width: 8rem;
  height: 4rem;
}
.SkillBanner_SkillBanner__x4rPl .SkillBanner_colorfulTheme__NBjdm:hover img {
  transform: translate(0%, -20%);
}
.SkillBanner_SkillBanner__x4rPl .SkillBanner_colorfulTheme__NBjdm:hover .SkillBanner_textContainer__jR0Eb {
  opacity: 1;
}
@media only screen and (max-width: 768px) {
  .SkillBanner_SkillBanner__x4rPl .SkillBanner_colorfulTheme__NBjdm {
    width: 3rem;
    height: 2rem;
  }
  .SkillBanner_SkillBanner__x4rPl .SkillBanner_colorfulTheme__NBjdm:hover img {
    transform: none;
  }
  .SkillBanner_SkillBanner__x4rPl .SkillBanner_colorfulTheme__NBjdm:hover .SkillBanner_textContainer__jR0Eb {
    opacity: 0;
  }
}
.SkillBanner_SkillBanner__x4rPl .SkillBanner_colorfulTheme__NBjdm {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  border: solid transparent;
  border-radius: 10rem;
}

@keyframes SkillBanner_fadeIn__qR7Tc {
  from {
    opacity: 0;
    right: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes SkillBanner_bottomToTop__oOJMg {
  0% {
    bottom: -100%;
  }
  100% {
    bottom: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SkillBanner/SkillBanner.module.scss","webpack://./src/assets/_globalStyleElements.module.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,sDAAA;AADF;AAGE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AADJ;AAIE;EACE,cAAA;EACA,aAAA;AAFJ;AAGI;EAHF;IAII,WAAA;IACA,YAAA;EAAJ;AACF;AANE;EAOE,uCAAA;EACA,kBAAA;AAEJ;AACE;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,qCAAA;AACJ;AAgDE;EAfE,gBAAA;EACA,sBAAA;EACA,kBAAA;AA9BJ;AA+CE;EACE,WAAA;EAdA,WAAA;EACA,WAAA;EACA,mDAAA;EACA,kBAAA;EACA,SAAA;EACA,yIAAA;AA9BJ;AA2CE;EAxBE,gBAAA;EACA,sBAAA;EACA,kBAAA;AAhBJ;AA0CE;EACE,WAAA;EAvBA,WAAA;EACA,WAAA;EACA,mDAAA;EACA,kBAAA;EACA,SAAA;EACA,yIAAA;AAhBJ;AAsCE;EAjCE,gBAAA;EACA,sBAAA;EACA,kBAAA;AAFJ;AAqCE;EACE,WAAA;EAhCA,WAAA;EACA,WAAA;EACA,mDAAA;EACA,kBAAA;EACA,SAAA;EACA,yIAAA;AAFJ;AAiCE;ECrDA,gBAAA;EACA,sBAAA;EACA,2CAnD4B;EDwG1B,sDAAA;EA1EA,WAAA;EACA,YAAA;AA8CJ;AA7CI;EACE,8BAAA;AA+CN;AA7CI;EACE,UAAA;AA+CN;AA7CI;EAgEF;IA/DI,WAAA;IACA,YAAA;EAgDJ;EA/CI;IACE,eAAA;EAiDN;EA/CI;IACE,UAAA;EAiDN;AACF;AAOE;EArDE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;AAiDJ;AAIE;ECrDA,gBAAA;EACA,sBAAA;EACA,0CAxD6B;ED6G3B,sDAAA;EAhFA,WAAA;EACA,YAAA;AAiFJ;AAhFI;EACE,8BAAA;AAkFN;AAhFI;EACE,UAAA;AAkFN;AAhFI;EAsEF;IArEI,WAAA;IACA,YAAA;EAmFJ;EAlFI;IACE,eAAA;EAoFN;EAlFI;IACE,UAAA;EAoFN;AACF;AAtBE;EA3DE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;AAoFJ;AAzBE;ECrDA,gBAAA;EACA,sBAAA;EACA,0CA9D6B;ED6B3B,WAAA;EACA,YAAA;AAmHJ;AAlHI;EACE,8BAAA;AAoHN;AAlHI;EACE,UAAA;AAoHN;AAlHI;EA4EF;IA3EI,WAAA;IACA,YAAA;EAqHJ;EApHI;IACE,eAAA;EAsHN;EApHI;IACE,UAAA;EAsHN;AACF;AAlDE;EAjEE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;AAsHJ;;AArDA;EACE;IACE,UAAA;IACA,QAAA;EAwDF;EAtDA;IACE,UAAA;EAwDF;AACF;AArDA;EACE;IACE,aAAA;EAuDF;EArDA;IACE,SAAA;EAuDF;AACF","sourcesContent":["@import 'src/assets/globalStyleElements.module';\n\n.SkillBanner {\n  padding: 0.5rem;\n  --experience-animation-color: rgba(255, 111, 105, 0.2);\n\n  .imageContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .imageContainer img {\n    height: 2.7rem;\n    width: 2.7rem;\n    @media only screen and (max-width: 768px) {\n      width: 2rem;\n      height: 2rem;\n    }\n    transition: transform 0.15s ease-in-out;\n    position: absolute;\n  }\n\n  .textContainer {\n    position: absolute;\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    right: 0;\n    bottom: 0.4rem;\n    text-align: center;\n    font-size: $globalFontSize * 0.8;\n    border-radius: 50vw;\n    opacity: 0;\n    transition: opacity 0.25s ease-in-out;\n  }\n\n  @mixin contentStyling {\n    width: 8rem;\n    height: 4rem;\n    &:hover img {\n      transform: translate(0%, -20%);\n    }\n    &:hover .textContainer {\n      opacity: 1;\n    }\n    @media only screen and (max-width: 768px) {\n      width: 3rem;\n      height: 2rem;\n      &:hover img {\n        transform: none;\n      }\n      &:hover .textContainer {\n        opacity: 0;\n      }\n    }\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    border: solid transparent;\n    border-radius: $globalBorderRadius * 10;\n\n  }\n\n  @mixin experienceIndicatorMixin {\n    overflow: hidden;\n    background-color: #ddd;\n    position: relative;\n  }\n\n  @mixin experienceIndicatorAnimationContainerMixin {\n    content: '';\n    width: 100%;\n    background-color: var(--experience-animation-color);\n    position: absolute;\n    bottom: 0;\n    animation: fadeIn 1.1s ease-in-out both,\n    bottomToTop 0.55s cubic-bezier(0.74, 0.06, 0.4, 0.92) both;\n  }\n\n  .beginner {\n    @include experienceIndicatorMixin;\n  }\n\n  .beginner::before {\n    height: 20%;\n    @include experienceIndicatorAnimationContainerMixin;\n  }\n\n  .moderate {\n    @include experienceIndicatorMixin;\n  }\n\n  .moderate::before {\n    height: 60%;\n    @include experienceIndicatorAnimationContainerMixin;\n  }\n\n  .experienced {\n    @include experienceIndicatorMixin;\n  }\n\n  .experienced::before {\n    height: 90%;\n    @include experienceIndicatorAnimationContainerMixin;\n  }\n\n  .darkTheme {\n    @include darkThemeContent;\n    --experience-animation-color: rgba(131, 133, 138, 0.2);\n    @include contentStyling;\n  }\n\n  .lightTheme {\n    @include lightThemeContent;\n    --experience-animation-color: rgba(105, 140, 255, 0.3);\n    @include contentStyling;\n  }\n\n  .colorfulTheme {\n    @include colorfulThemeContent;\n    @include contentStyling;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    right: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes bottomToTop {\n  0% {\n    bottom: -100%;\n  }\n  100% {\n    bottom: 0;\n  }\n}\n","$globalFontFamily: 'Courier New', monospace;\n$globalFontSize: 1.2rem;\n\n$globalBorderRadius: 1rem;\n$globalHomeContentContainerPadding: 2.5rem;\n\n$globalDarkColor: #212121;\n$globalLightColor: #fafafa;\n$globalUnderlayRGBAColorDark: rgba(255, 255, 255, 0.05);\n$globalUnderlayRGBAColorLight: rgba(208, 209, 255, 0.5);\n\n$globalHighlightColor: #f6a3a0;\n$globalHighlightColorDark: #fafafa;\n$globalHighlightColorLight: #454555;\n\n\n$colorsReact: #61dafb;\n$colorsKotlin: #7f52ff;\n$colorsReactRgba: rgba(97, 218, 251, 0.2);\n\n$gradientColor1: #845ec2;\n$gradientColor1: #d65db1;\n$gradientColor1: #ff9671;\n$gradientColor1: #ffc75f;\n$gradientColor1: #f9f871;\n\n@mixin darkTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: $globalDarkColor;\n  color: $globalLightColor;\n  a {\n    color: white;\n  }\n}\n\n@mixin lightTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: $globalLightColor;\n  color: $globalDarkColor;\n  a {\n    color: $globalDarkColor;\n  }\n}\n\n@mixin colorfulTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: #91f88b;\n  color: $globalDarkColor;\n  a {\n    color: $globalDarkColor;\n  }\n}\n\n@mixin darkThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorDark;\n}\n\n@mixin lightThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorLight;\n}\n\n@mixin colorfulThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorLight;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SkillBanner": `SkillBanner_SkillBanner__x4rPl`,
	"imageContainer": `SkillBanner_imageContainer__Yv1Ad`,
	"textContainer": `SkillBanner_textContainer__jR0Eb`,
	"beginner": `SkillBanner_beginner__p6hjR`,
	"fadeIn": `SkillBanner_fadeIn__qR7Tc`,
	"bottomToTop": `SkillBanner_bottomToTop__oOJMg`,
	"moderate": `SkillBanner_moderate__+tBf3`,
	"experienced": `SkillBanner_experienced__sNIYc`,
	"darkTheme": `SkillBanner_darkTheme__o6Db+`,
	"lightTheme": `SkillBanner_lightTheme__xkiuG`,
	"colorfulTheme": `SkillBanner_colorfulTheme__NBjdm`
};
export default ___CSS_LOADER_EXPORT___;
